import { render, staticRenderFns } from "./Squared.vue?vue&type=template&id=4981c162"
import script from "./Squared.vue?vue&type=script&lang=js"
export * from "./Squared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports